const GOOGLE_API_KEY ="AIzaSyB2_Ppru607SZnvJSIVDn6I-is9hfx1rXg"
export const YOUTUBE_VIDEOS_API ='https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&maxResults=60&regionCode=IN&key=' + GOOGLE_API_KEY ;

export const YOUTUBE_SEARCH_API ='https://suggestqueries.google.com/complete/search?client=firefox&ds=yt&q=';
export const LIVE_CHAT_COUNT = 25;

